module.exports = __webpack_public_path__ + "static/media/coffee-promo-dt-fr.3e91947d.mp4";